import { render } from "./FormCalendar.vue?vue&type=template&id=be276ce6"
import script from "./FormCalendar.vue?vue&type=script&lang=js"
export * from "./FormCalendar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__